// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"3b21e610","141":"00dd26bb","235":"2a01f8c8","305":"3ed14f02","313":"0193f6fa","358":"e33f452c","716":"192dbe28","745":"00dd26bb"}[chunkId] + ".chunk.css";
};